import AddLookup from "../../../Components/InputComponents/AddLookup";
import { useSearchParams } from "react-router-dom";

function AddDesignation() {
  const [searchParams] = useSearchParams();
  const redirectURL = `/DesignationLookup?${searchParams.toString()}`;

  return (
    <AddLookup
      title="Add Designation"
      alert="Designation Added Successfully"
      addDataAPIEndpoint="/Designation/add"
      redirectURL={redirectURL}
      sections={[
        {
          fields: [
            {
              type: "text",
              label: "Designation",
              name: "DI_Name",
              required: true, // Validation rule added here
              maxLength:70
            },
            {
              type: "select",
              label: "Status",
              name: "DI_Status",
              required: true, // Validation rule added here         
              options: [
                { label: "Active", value:'1'},
                { label: "Inactive", value: '0'},
              ],
            },
          ],
        },
      ]}
      validationRules={{
        DI_Name: {
          required: true,
          
        },
        DI_Status: {
          required: true,
        },
      }}
    />
  );
}

export default AddDesignation;
